import React, { useEffect, useMemo, useRef } from 'react'

import useGetProductListInfiniteQuery from 'hooks/queries/product/useGetProductListInfiniteQuery'

import Presenter from 'components/presenters/commerce/main/StoreProdList'
import { flatMapDeep } from 'lodash'
import useInfinitiScroll from 'hooks/common/useInfinityScroll'

export default function ShopMainProdList() {
  const scrollRef = useRef(null)

  const { fetchNextPage, data } = useGetProductListInfiniteQuery(
    { limit: 20 },
    { enabled: !!scrollRef },
  )
  const prodList = useMemo(() => {
    if (!data) return []
    return flatMapDeep(data.pages, ({ data }) => [...data.products])
  }, [data])

  const [count] = useInfinitiScroll({
    target: scrollRef,
    targetArray: prodList,
    threshold: 0.2,
    endPoint: 1,
  })

  useEffect(() => {
    fetchNextPage()
  }, [count, fetchNextPage])

  return <Presenter ref={scrollRef} prodList={prodList} />
}
